import { BodyText, withStyles } from 'vopay';
import { Title, Card } from 'UI';
import { useTranslation } from 'react-i18next';
import usePartnerCreationFormConfig from '@/components/Partners/PartnerCreation/usePartnerCreationFormConfig';
import styles from './PartnerCreationDrawerForm.module.scss';

const cn = withStyles(styles);

// The drawer footer's Confirm button submits this form by id.
export const PARTNER_CREATION_FORM_ID = 'partnerCreationForm';

type PartnerCreationDrawerFormProps = Pick<
  ReturnType<typeof usePartnerCreationFormConfig>,
  'ctx' | 'renderFormElements' | 'businessInfoConfig'
>;

export default function PartnerCreationDrawerForm({
  ctx,
  renderFormElements,
  businessInfoConfig,
}: PartnerCreationDrawerFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.Create' });

  return (
    <form id={PARTNER_CREATION_FORM_ID} onSubmit={ctx.handleSubmit} className={cn('form')}>
      <div className={cn('detailsHeader')}>
        <Title level="3">{t('detailsTitle', { defaultValue: 'Details' })}</Title>

        <BodyText className={cn('description')}>
          {t('detailsDescription', {
            defaultValue: 'Basic contact & business information for partner account creation.',
          })}
        </BodyText>
      </div>

      <Card variant="section" className={cn('sectionCard')}>
        <Title level="4">{t('businessInformation', { defaultValue: 'Business Information' })}</Title>
        <div className={cn('grid')}>{renderFormElements({ config: businessInfoConfig })}</div>
      </Card>
    </form>
  );
}
